<div class="row" [class.print-mode]="printMode">
	<div class="col-12">
		<div class="top-exposure-image-container">
			<div class="exposure-picture clickable" (click)="openPostPage()">
				<blurry-backdrop-image [image]="topExposure.picture" (afterLoaded)="onLoadedImage()" (error)="onLoadedImageError()"></blurry-backdrop-image>
			</div>
			<div class="exposure-date">
				<span *ngIf="topExposure.date">{{formatExposureDate(topExposure.date)}}</span>
			</div>
		</div>
	</div>

	<div class="col-12 platform-title">
		<div class="{{getPlatformIcon().toLowerCase() + '-icon'}} icon-platform"></div>
		<span class="exposure-type-title">{{exposureType}}</span>
	</div>

	<div class="col-12 d-flex justify-content-center align-items-center">
		<span class="exposure-count">{{formatExposureNumber(topExposure.value)}}</span>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/influencer-top-exposures/influencer-top-exposure-item/influencer-top-exposure-item.component.html